import React, { useState } from "react";
import styles from "./ArtworkCard.module.scss";
import HeartIcon from "components/svgs/HeartIcon";
import BagIcon from "components/svgs/BagIcon";
import { useNavigate } from "react-router-dom";
import InBusketIcon from "components/svgs/InBusketIcon";

const ArtworkCard = ({ item }) => {
  const [liked, setLiked] = useState(false);
  const [addToBasket, setAddToBasket] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      className={styles.card}
      onClick={() => navigate(`/painting/${item.id}`)}
    >
      <div className={styles.cardImage}>
        <img src={item.image} alt={item.title} />
      </div>
      <div className={styles.cardBody}>
        <div className={styles.cardTitle}>
          <div className={styles.artworkTitle} title={item.title}>
            {item.title}
          </div>
          <div className={styles.icons}>
            <div
              className={`${styles.heartIcon} ${liked ? styles.liked : ""}`}
              title="Like"
              onClick={(e) => {
                e.stopPropagation();
                setLiked(!liked);
              }}
            >
              <HeartIcon />
            </div>
            <div
              className={`${styles.addToBasket}`}
              title="Add To Basket"
              onClick={(e) => {
                e.stopPropagation();
                setAddToBasket(!addToBasket);
              }}
            >
              {!addToBasket ? <BagIcon /> : <InBusketIcon />}
            </div>
          </div>
        </div>
        <div className={styles.cardArtistFullName} title={item.artistFullName}>
          {item.artistFullName}
        </div>
        <div className={styles.cardSubFooter}>{item.country}</div>
        <div className={styles.cardFooter}>
          <div className={styles.info}>
            <span>{item.sizes}</span>
            <span>{item.material}</span>
          </div>
          <div className={styles.price}>{item.price}</div>
        </div>
      </div>
    </div>
  );
};

export default ArtworkCard;
